import { computed, getCurrentInstance } from 'vue'
import WebhookForm from '@/views/templates/WebhookForm.vue'
import AnthropicForm from '@/views/templates/AnthropicForm.vue'
import OpenAIForm from '@/views/templates/OpenAIForm.vue'
import LosantForm from '@/views/templates/LosantForm.vue'
import DatadogForm from '@/views/templates/DatadogForm.vue'
import LastfmForm from '@/views/templates/LastfmForm.vue'
import OpenWeatherForm from '@/views/templates/OpenWeatherForm.vue'
import IFTTTForm from '@/views/templates/IFTTTForm.vue'
import LambdaForm from '@/views/templates/LambdaForm.vue'

type I18nProxy = { $t?: (key: string) => string }

export function useIntegrationTemplates() {
  const vm = getCurrentInstance()
  const proxy = vm?.proxy as unknown as I18nProxy

  const getTemplateLabel = (template: string): string => {
    switch (template) {
      case 'webhook':
        return proxy.$t ? proxy.$t('integrations.customWebhook') : 'Custom Webhook'
      case 'lambda':
        return proxy.$t ? proxy.$t('integrations.customLambda') : 'Custom Function'
      case 'anthropic-chat':
        return 'Anthropic Chat'
      case 'openai-chat':
        return 'OpenAI Chat'
      case 'losant':
        return 'Losant Enterprise IoT Platform'
      case 'datadog':
        return 'Datadog'
      case 'lastfm':
        return 'Last.fm'
      case 'openweather':
        return 'OpenWeather'
      case 'ifttt':
        return 'IFTTT'
      default:
        return template
    }
  }

  const getTemplateComponent = (template: string) => {
    switch (template) {
      case 'anthropic-chat':
        return AnthropicForm
      case 'openai-chat':
        return OpenAIForm
      case 'losant':
        return LosantForm
      case 'datadog':
        return DatadogForm
      case 'lastfm':
        return LastfmForm
      case 'openweather':
        return OpenWeatherForm
      case 'ifttt':
        return IFTTTForm
      case 'lambda':
        return LambdaForm
      case 'webhook':
      default:
        return WebhookForm
    }
  }

  const getTemplateIcon = (template: string): string => {
    switch (template) {
      case 'webhook':
        return 'webhook'
      case 'lambda':
        return 'function-variant'
      case 'anthropic-chat':
        return 'message-text-outline'
      case 'openai-chat':
        return 'message-text'
      case 'losant':
        return 'cloud-outline'
      case 'datadog':
        return 'chart-line'
      case 'lastfm':
        return 'music'
      case 'openweather':
        return 'weather-partly-cloudy'
      case 'ifttt':
        return 'puzzle-outline'
      default:
        return 'puzzle-outline'
    }
  }

  const getLanguageIcon = (language: string): string => {
    switch ((language || '').toLowerCase()) {
      case 'javascript':
        return 'language-javascript'
      case 'python':
        return 'language-python'
      case 'ruby':
        return 'language-ruby'
      default:
        return 'code-tags'
    }
  }

  const getLanguageLabel = (language: string): string => {
    switch ((language || '').toLowerCase()) {
      case 'javascript':
        return 'JavaScript'
      case 'python':
        return 'Python'
      case 'ruby':
        return 'Ruby'
      default:
        return language
    }
  }

  return {
    getTemplateLabel,
    getTemplateComponent,
    getTemplateIcon,
    getLanguageIcon,
    getLanguageLabel
  }
}
